import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import ScribbleImage, { ScribbleVariant } from "./ScribbleImage";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            position: "relative",
        },
        childContainer: {
            position: "relative",
            zIndex: 50,
        },
        scribbleContainer: {
            position: "absolute",
            pointerEvents: "none",
            zIndex: 10,
            "& img": {
                width: "100%",
            },
        },
    });
});

type IClasses = Partial<ReturnType<typeof useStyles>>;

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: ScribbleVariant;
    classes?: IClasses;
}

export default function Scribble(props: IProps) {
    const { variant = "v1", className, children, classes: overrideClasses, ...rest } = props;
    const classes = useStyles();

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            <div className={clsx(classes.childContainer, overrideClasses?.childContainer)}>
                {children}
            </div>
            <div className={clsx(overrideClasses?.scribbleContainer, classes.scribbleContainer)}>
                <ScribbleImage variant={variant} />
            </div>
        </div>
    );
}
